// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CaretLeftOutlinedSvg from "@fishx/icons-svg/es/asn/CaretLeftOutlined";
import FishxIcon from '../components/FishxIcon';

var CaretLeftOutlined = function CaretLeftOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: CaretLeftOutlinedSvg
  }));
};

CaretLeftOutlined.displayName = 'CaretLeftOutlined';
export default React.forwardRef(CaretLeftOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/CaretLeftOutlined.js
// module id = 2174
// module chunks = 0